module.exports = __webpack_public_path__ + "img/23.646d1819.png";